import { C, HEADSHOT } from "../data/content";

export const Portrait = () => (
  <div className="host-panel" data-testid="host-portrait-panel">
    <img src={HEADSHOT} alt="Darren Gussick, NEXA Mortgage" className="absolute inset-0 w-full h-full object-cover" />
    <div className="corner-mark top-3 left-3 border-t border-l" />
    <div className="corner-mark top-3 right-3 border-t border-r" />
    <div className="corner-mark bottom-3 left-3 border-b border-l" />
    <div className="corner-mark bottom-3 right-3 border-b border-r" />
  </div>
);

const creds = [
  ["COMPANY", C.hostCompany],
  ["NMLS#", C.hostNmls],
  ["CO. NMLS#", C.hostCompanyNmls],
  ["LICENSED IN", C.hostLicenseStates],
];

export const HostSection = () => (
  <section id="host" className="py-28 px-6 lg:px-12" data-testid="host-section">
    <div className="max-w-[1200px] mx-auto">
      <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-12">[005] — YOUR HOST</p>
      <div className="grid md:grid-cols-[minmax(280px,420px)_1fr] gap-14 items-start">
        <Portrait />
        <div>
          <h2 className="h1-display text-[clamp(26px,3vw,42px)] mb-6">GUIDANCE FROM SOMEONE WHO WORKS INSIDE THE PROCESS.</h2>
          <div className="h-px w-24 mb-8" style={{ background: "var(--accent)" }} />
          <div className="space-y-5 text-[15px] text-white/55 leading-[1.8]">
            <p>
              I'm {C.hostName}, a licensed loan officer with {C.hostCompany}, serving VA-eligible homebuyers across Florida, Texas, and Pennsylvania. Day in and day out, I sit on the lender's side of the table — which means I see exactly where deals get delayed, where buyers get underestimated, and where earned VA benefits go unused.
            </p>
            <p>
              Here's what I've learned: most buyers don't struggle with VA qualification because their numbers are bad. They struggle because nobody ever explained what actually matters — entitlement, residual income, soft-pull reviews — in plain English, using their real numbers instead of a generic online form.
            </p>
            <p>
              That's exactly what this webinar fixes. In 45 minutes, I walk you through the same review I do live with buyers every week — so you leave knowing your position, your checklist, and your next step. Educational only, no obligation, and no hard credit pull required to attend.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-px mt-10 border border-white/[0.08] bg-white/[0.08]" data-testid="credential-grid">
            {creds.map(([k, v]) => (
              <div key={k} className="bg-[#080808] p-5">
                <p className="mono text-[10px] tracking-[0.25em] text-white/35 mb-2">{k}</p>
                <p className="text-[13px] font-bold">{v}</p>
              </div>
            ))}
          </div>
          <button className="btn-accent cta mt-10" data-testid="host-cta"
            onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}>
            ✓ RESERVE MY FREE SEAT
          </button>
        </div>
      </div>
    </div>
  </section>
);
